// src/theme.ts
export const theme = {
    primary: "bg-[#2bee6c] hover:bg-[#24d15d] text-slate-900 font-black",
    primaryText: "text-[#2bee6c]",
    secondary: "bg-slate-900 hover:bg-slate-800 text-white",
    accent: "bg-purple-600 hover:bg-purple-700 text-white",
    background: "bg-white",
    surface: "bg-white border border-slate-50",
    textPrimary: "text-slate-900",
    textSecondary: "text-slate-500",
    border: "border-slate-100",
    headingFont: "font-black tracking-tight",
    bodyFont: "font-medium",
    radius: "rounded-[40px]",
    shadow: "shadow-sm hover:shadow-xl transition-all duration-300",
} as const;
